import React from 'react'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput } from 'components/FormElements/ReduxForm'
// hooks
import { useShowModal } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// context
import { KPICreationContext } from 'context/index'

// types
interface IIncomingProps {
  canModify: boolean
  label: string
}

const ResultTargetText: React.FC<IIncomingProps> = ({ canModify, label }) => {
  const { isCreateForm } = React.useContext(KPICreationContext) as any

  const { showModal } = useShowModal({ modalType: Modals.KPI_RESULTS_MODAL })

  const showResultTargetsModal = () => {
    if (canModify) {
      showModal({ isCreateForm })
    }
  }

  return (
    <Grid>
      <ReduxInput
        disabled={!canModify}
        label={label}
        name={'resultTargetText'}
        onClick={showResultTargetsModal}
        readOnly={canModify}
      />
    </Grid>
  )
}

export default ResultTargetText
